import React from "react";
import styled from "styled-components";
import CloseAllCheckbox from "./CloseAllCheckbox";
import ClosePortfolioCheckbox from "./ClosePortfolioCheckbox";
import PortfolioList from "../portfolio/PortfolioList";
import {PortfolioRow} from "../portfolio/PortfolioRow";

const Container = styled.div`
    display: flex;
    flex-grow: 1;
    padding-top: 21px;
    padding-right: 14px;
    padding-left: 14px;
`;

const Header = styled.div`
    font-size: 11px;
    font-weight: bold;
    flex-shrink: 0;
    padding-left: 11px;
`;

const PortfolioName = styled.div`
    font-size: 12px;
    padding-left: 11px;
`;

const sortPortfolios = (p1, p2) => {
    return p1.name.localeCompare(p2.name);
};

const ClosePortfolioList = ({portfolios, closing, ideaActions}) => {
    const allOpenPortfolios = portfolios.filter(p => p.open).sort(sortPortfolios);

    const rowRenderer = (portfolio, style) => {
        return (
            <PortfolioRow key={portfolio.id} style={style}>
                <ClosePortfolioCheckbox portfolio={portfolio} closing={closing} ideaActions={ideaActions}/>
                <PortfolioName className="t-portfolio-name">{portfolio.name}</PortfolioName>
            </PortfolioRow>
        );
    };
    return (
        <Container>
            <PortfolioList portfolioRenderer={rowRenderer}
                           portfolios={allOpenPortfolios}
                           headerElements={
                               <React.Fragment>
                                   <CloseAllCheckbox allOpenPortfolios={allOpenPortfolios}
                                                     closing={closing}
                                                     ideaActions={ideaActions}/>
                                   <Header>All Portolio(s)</Header>
                               </React.Fragment>
                           }>
            </PortfolioList>
        </Container>
    );
};

export default ClosePortfolioList;